export function attachRevealTarget(button: HTMLElement): void {
    const targetId = button.dataset.revealTarget;
    if (!targetId) {
        return;
    }

    const target = document.getElementById(targetId);
    if (!target) {
        return;
    }

    button.addEventListener("click", () => {
        target.classList.remove('mtx-hidden');
        button.classList.add('mtx-hidden');
    });
}